module.exports = __webpack_public_path__ + "img/horizontal_7_2_7042.3610934e.png";